import request from "superagent";
import { getTabToken } from "../../common/MetaActions";

/**
 * Plugin that adds authentication headers to API requests
 *
 * Adds:
 * - Authorization: Bearer {token}
 * - Accept: application/json
 */
export function authPlugin() {
  return function (req: request.SuperAgentRequest) {
    const token = getTabToken();

    return req.set("Authorization", `Bearer ${token}`);
  };
}
